export function buyerApplicationEditQueryDefinition(breederProfileId) {
  return {
    // TODO: may want to add a new endpoint entirely
    url: `/api/breeder_profiles/${breederProfileId}/buyer_applications/new_or_edit.json`,
    defaultValue: {
      buyer_application: {}
    }
  };
}

export function buyerApplicationUpdateMutationDefinition(
  breederProfileId,
  buyerApplicationId
) {
  return {
    url: `/api/breeder_profiles/${breederProfileId}/buyer_applications/${buyerApplicationId}.json`,
    method: 'PUT'
  };
}
